import { useSelector } from 'react-redux';
import { RootState } from 'store';

import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { CARS_STATE } from '../../constants';

const useLocationSharingConstraintsLoadingStatus = () => useSelector(
  (state: RootState) => state[CARS_STATE].locationSharingConstraints.loadingStatus
);

export const useIsLocationSharingConstraintsLoading = () => {
  const locationSharingConstraintsLoadingStatus = useLocationSharingConstraintsLoadingStatus();
  return checkIsLoading(locationSharingConstraintsLoadingStatus);
};

export const useIsLocationSharingConstraintsDone = () => {
  const locationSharingConstraintsLoadingStatus = useLocationSharingConstraintsLoadingStatus();
  return checkIsLoadingDone(locationSharingConstraintsLoadingStatus);
};

export const useLocationSharingConstraints = () => useSelector(
  (state: RootState) => state[CARS_STATE].locationSharingConstraints.data
);
